import { formatCnpj } from "../../../utils/format-cnpj";
import { formatCpf } from "../../../utils/format-cpf";
import { BloqueioMotivo } from "../types";

/**
 * Extrai CPFs/CNPJs de um texto colado ou de um CSV: separa por quebra de linha,
 * vírgula, ponto e vírgula ou espaço, tira a máscara, ignora tokens sem dígito
 * (cabeçalho) e repetidos. A validação de tamanho fica no backend, que devolve
 * os inválidos em `failed`.
 */
export function parseDocumentos(texto: string): string[] {
  const docs = texto
    .split(/[\s,;]+/)
    .map((t) => t.toUpperCase().replace(/[^0-9A-Z]/g, ""))
    .filter((t) => /\d/.test(t));
  return Array.from(new Set(docs));
}

export const formatDocumento = (doc?: string | null) => {
  if (!doc) return "-";
  return doc.length === 11 ? formatCpf(doc) : formatCnpj(doc);
};

export const formatDataHora = (iso?: string | null) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString("pt-BR", {
    timeZone: "America/Sao_Paulo",
    dateStyle: "short",
    timeStyle: "short",
  });
};

// Motivos que não estão na lista do gestor: os do cliente e o da migração.
const ROTULOS_EXTRA: Record<string, string> = {
  legado_inativo: "Legado (cadastro inativo)",
  desligado: "Desligado",
  conduta: "Conduta",
  pedido_operacao: "Pedido da operação",
  outro: "Outro",
};

export const rotuloMotivo = (
  codigo: string | null | undefined,
  texto: string | null | undefined,
  motivos: BloqueioMotivo[] = [],
) => {
  const rotulo = codigo
    ? (motivos.find((m) => m.codigo === codigo)?.rotulo ??
      ROTULOS_EXTRA[codigo] ??
      codigo)
    : null;
  if (rotulo && texto)
    return codigo === "outro" ? texto : `${rotulo} — ${texto}`;
  return rotulo ?? texto ?? "Sem motivo";
};
